export const filterQueryParams = (params: string, paramToRemove: string) => {
  const searchParams = new URLSearchParams(params);
  searchParams.delete(paramToRemove);

  return searchParams.toString();
};
